import { BaseControlDef, BaseElementDefBase } from "./BaseElementDef";
import { FileSettings } from "@cs-ts/file-settings";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { CalculationContext } from "./__CalculationContextInterface";
import { map } from "rxjs/operators";
import { FormFileItem } from "@cs/FormFileItem";

export interface InputFormFileItem extends FormFileItem {
    contentType: string;
    valueId: string;
}
export interface OutputFormFileItem extends FormFileItem {
    contentType: string;
    valueId: string;
    removeExisting?: boolean;
}

const TYPE_NAME = "MI.Common.DynamicForms.Models.DFFile";

export default class FileDef extends BaseControlDef<FileSettings, FormDefinitionItem<FileSettings>, FormFileItem, unknown> {
    declare valueId: string;
    declare fileName: string;
    declare fileSize: string;
    declare contentType: string;
    declare fileUrl: string;
    declare isFileUpload: boolean;
    declare uploadStatus: string | null;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormFileItem, definitionData: FormDefinitionItem<FileSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = TYPE_NAME; // TODO - not hardcoded?
        this.isFileUpload = true;
        this.uploadStatus = null;
        this.isFocusable = true;
    }
    setData(data: FormFileItem, excludeChildren: boolean) {
        super.setData(data, excludeChildren);
        this._setFileData(data as InputFormFileItem);
    }
    setFileData(data: InputFormFileItem) {
        this._setFileData(data);
        this.markEdited();
    }
    _setFileData(data: InputFormFileItem) {
        if (data == null) {
            //this.setKey({}, "hasValue", "_hasValue"); // TODO conflict with base value?
            const fileDependencies = this.getValueFromDependencies() as Record<string, string>;
            if (fileDependencies != null) {
                //@ts-expect-error
                this.setKey(fileDependencies, "fileName");
                //@ts-expect-error
                this.setKey(fileDependencies, "fileUrl");
            }
            this.setKey(null, "valueId");
            this.setKey(null, "fileName");
            this.setKey(null, "fileSize");
            this.setKey(null, "contentType");
            this.setKey(null, "fileUrl");
            return;
        }
        if (!data.hasValue) {
            this.setKey(data, "hasValue", "_hasValue");
        }
        this.setKey(data, "valueId");
        this.setKey(data, "fileName");
        this.setKey(data, "fileSize");
        this.setKey(data, "contentType");
        this.setKey(data, "fileUrl");
        if (data.hasValue) {
            this.setKey(data, "hasValue", "_hasValue");
        }
    }
    getData(excludeChildren?: boolean) {
        const result = super.getData(excludeChildren) as OutputFormFileItem;
        result.valueId = this.valueId;
        result.fileName = this.fileName;
        result.fileSize = parseInt(this.fileSize);
        result.contentType = this.contentType;
        if (!this._hasValue) {
            result.removeExisting = true;
        }
        if (!this.valueId) {
            this.uploadStatus = null;
        }
        return result;
    }
    rules$() {
        return super.rules$().pipe(
            map(result => {
                const requiredKeys = Object.keys(result).filter(i => i.indexOf("data-val-required") == 0 && i.indexOf("data-val-requiredfile") == -1);
                requiredKeys.forEach(k => {
                    const newK = "data-val-requiredfile" + k.substring("data-val-required".length);
                    result[newK] = result[k];
                    delete result[k];
                });
                return result;
            }),
        );
    }
}

export function isFileDef(i: BaseElementDefBase): i is FileDef {
    return i.typeName == TYPE_NAME;
}
